import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, dark = false, testid }) => (
  <span
    data-testid={testid}
    className={`inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] ${dark ? "text-gold" : "text-gold"}`}
  >
    <span className="h-px w-6 bg-gold" />
    {children}
  </span>
);
